<div class="row" *ngIf="offer">
	<div class="col-4">
		<app-reservation-summary-accommodation-offer-rooms
			[offer]="offer"
		></app-reservation-summary-accommodation-offer-rooms>
	</div>
	<div
		class="col d-flex flex-column gap-2"
		cdkDropList
		[cdkDropListData]="offer.slot"
		(cdkDropListDropped)="drop($event, offer)"
	>
		<div class="wrapper participantsContainer d-flex flex-column gap-2">
			<app-reservation-accommodation-offer-participant
				cdkDrag
				[cdkDragDisabled]="isParticipantDisabled(slot) || !service.slotDragging"
				*ngFor="let slot of offer.slot"
				[slot]="slot"
			></app-reservation-accommodation-offer-participant>
		</div>
	</div>
</div>
